import { Box, HStack, Progress, Text } from '@chakra-ui/react'
import { useEffect, useMemo, useState } from 'react'
import { useThemeColors } from '@/hooks/useThemeColors'
import { getSlaStatus, getSlaTone } from '@/lib/utils/slaStatus'

type Props = {
  slaDueAt: string | null | undefined
}

export default function SlaStatusStrip({ slaDueAt }: Props) {
  const colors = useThemeColors()
  const [now, setNow] = useState(Date.now())

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60_000)
    return () => clearInterval(id)
  }, [])

  const sla = useMemo(() => getSlaStatus(slaDueAt, now), [slaDueAt, now])
  const tone = getSlaTone(sla.urgency)

  const displayLabel = sla.toneLabel ?? sla.label

  return (
    <Box
      p={3}
      borderRadius="md"
      border="1px solid"
      borderColor={tone.border}
      bg={tone.bg}
    >
      <HStack justify="space-between" align="flex-start" gap={3} flexWrap="wrap">
        <Box minW={0}>
          <Text fontSize="xs" fontWeight="700" color={colors.textSecondary} textTransform="uppercase" mb={1}>
            SLA
          </Text>
          <Text fontSize="sm" fontWeight="700" color={tone.color}>
            {displayLabel}
          </Text>
          {sla.detail ? (
            <Text fontSize="xs" color={colors.textMuted} mt={0.5}>
              {sla.detail}
            </Text>
          ) : null}
        </Box>
      </HStack>
      {sla.progressPercent != null && sla.urgency !== 'none' ? (
        <Progress
          value={sla.progressPercent}
          size="xs"
          colorScheme={tone.scheme}
          borderRadius="full"
          mt={2}
        />
      ) : null}
    </Box>
  )
}
